import { css } from 'styled-system/css';

export const valueStyle = css.raw({
  textStyle: 'text.small',
  color: 'greyWhite.lightGrey1',
  textAlign: 'end',
});
